<style lang='less' scoped>
::-webkit-scrollbar {width: 0.06rem;height: 0.05rem;border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
::-webkit-scrollbar-track-piece {border: 1px solid gray;border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
::-webkit-scrollbar-thumb:vertical {height: 0.05rem;background-color: gray; border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
::-webkit-scrollbar-thumb:horizontal {width: 7px;background-color: gray;border-radius: 0.15rem;-webkit-border-radius: 0.15rem;}
.cx-fi{margin-right:0.02rem;font-size: 0.12rem;}
.container{position:absolute;width: 400px;height: 350px;background:rgba(1,34,67, 0.9);border-radius: 15px;z-index: 13;// 比弹框优先级低
  .head{display: flex;justify-content: space-between;width: 100%;height: 10%;align-items: center;color: #fff;font-size: 16px;background-color: #20cbc3;
background-image: linear-gradient(198deg, #20cbc3 0%, #2189da 52%, #20cbc3 100%);
overflow: hidden;
border-top-left-radius: 0.15rem;
border-top-right-radius: 0.15rem;
    .title{display: flex;flex-direction: column;justify-content: center;padding-right: 52px;height: 100%;text-indent: 1em;background: url('./dialog-left-bg.png');background-size: 100% 100%;}
    .el-icon{margin-right: 10xp;font-style: normal;cursor: pointer;}}}
  .body{height:330px;padding: 10px 20px;overflow: hidden;}
  .footer{display: flex;justify-content: space-around;padding: 5px 8px;height: 13%;font-size: 14px;color: white;align-items: center;border-top: 1px dashed rgba(0,227,202);
    div{cursor: pointer;}
    img{vertical-align: middle;}}
  .bottom-arrow{position: absolute;left: 50%;bottom: -20px;width: 0;height: 0;border-left: 8px solid transparent;border-right: 8px solid transparent;border-top: 20px solid #fff;transform: translateX(-50%);}
  /deep/ .el-form{display: flex;flex-wrap: wrap;justify-content: space-between;flex-direction: column;}
  /deep/ .el-form--inline .el-form-item{margin-right: 0;}
/deep/ .el-form-item{display:flex;margin-bottom: 0;width: 100%;margin-top: 3px;}
/deep/ .el-form-item__label{height: 32px;line-height: 32px;font-weight: bold; color: white !important;}//max-width: 1.5rem;
::v-deep .el-form-item>.el-form-item__label::before{
  content: '';
  width: 5px;height: 16px;background: rgba(0,227,202);margin-top: 8px;margin-right: 4px;
}
::v-deep .el-form-item>.el-form-item__label::after{
  content: ':';
  color: white !important;
  margin-left: 1px;
}
/deep/ .el-form-item__label{
  color: white !important;
}
/deep/ .el-form-item__content{line-height: 32px;color: rgba(0,227,202);align-items: flex-start;}
.btnclass:hover{text-decoration: underline;color: rgba(0,227,202);}
/deep/ .el-tabs__content {
    height: 240px;
    overflow: auto;
    position: relative;
}
/deep/.el-tabs__item {
  color: #fff;
}
/deep/.el-icon-close{margin-right: 10px;}
</style>

<template>
<div class="container">
    <div class="head">
      <div class="title">{{title}}</div>
      <!-- <el-icon :size="16" color="white" @click="closeClick">X</el-icon> -->
      <i class="el-icon-close" @click="closeClick"></i>
    </div>
    <div class="body" :style="[btnList.length ? 'height: calc(2.5rem - 18% - 0.23rem - 0.4rem);' : 'height: 1.87rem;']">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="属性查看" name="first">
          <el-form :inline="true" label-position="left">
            <el-form-item v-for="item in formList" :key="item.colname" :label="item.namec">
              {{ item.value }}
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="元数据" name="second">
          <el-form :inline="true" label-position="left">
            <el-form-item v-for="item in metadata" :key="item.colname" :label="item.namec">
              {{ item.value }}
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="footer" v-if="btnList.length">
      <div v-for="(btn, index) in btnList" @click="btn.click" :key="index" class="btnclass">
        <span :class="btn.iconClass"  :style="{color: btn.color}"></span>{{ btn.name }}
      </div>
    </div>
    <div class="bottom-arrow"></div>
</div>
</template>

<script>
/**
 * 组件名称: 气泡弹窗
 * 研发时间: 2022.12.09
 * 研发人员: 张浩
 * 功能说明:
 *
 * 调用说明:
 * @prop  {String}        tilte                  汽包框名字
 * @prop  {Array}         formList               表单列表数据（格式：[{ value: '', namec: '孔编码:', colname: 'holecode' }]）
 * @prop  {Array}         btnList                表单列表数据（格式：[{ name: '详细信息', iconClass: 'cx-fi ic-service', color: '#467cbe', click: this.lookDetail }]）
 *
 * 事件说明:
 * @event 事件名             参数解构                        事件和参数说明
 *
 */

/**
 * 维护历史:
 * 修改时间  人员      说明
 */
export default {
  data()
  {
    return {
      activeName: 'first'
    }
  },
  props: {
    title: { type: String, default: '' },
    formList: { type: Array, default: () => [] },
    btnList: { type: Array, default: () => [] },
    metadata: { type: Array, default: () => [] },
    closeBack: {
      type: Function,
      default: () => () =>
      {}
    }
  },
  created()
  {
  },
  methods: {
   
    // 关闭属性查看弹窗
    closeClick()
    {
      if (this.closeEvent)
      {
        delete window.popups
        this.closeEvent()
      }
    },
    handleClick(val)
    {
      console.log(val.props)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/popup/DpIndex.vue